import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full noselect lg:hidden fixed bottom-0 z-10 text-gray-600 dark:text-white bg-white dark:bg-gray-800" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full mx-auto border-b-1 rounded-lg border-gray-200 dark:border-gray-700" }, null, -1)
const _hoisted_3 = { class: "grid grid-cols-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "text-xl appFont px-5" }
const _hoisted_6 = { class: "p-3 flex flex-wrap" }
const _hoisted_7 = ["innerHTML", "onClick"]
const _hoisted_8 = {
  key: 1,
  class: "text-xl appFont px-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestLoader = _resolveComponent("RequestLoader")!
  const _component_MagicWand = _resolveComponent("MagicWand")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_HideKeyboard = _resolveComponent("HideKeyboard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_RequestLoader),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHelper && _ctx.openHelper(...args))),
        class: "transition mx-auto duration-150 p-3 w-full ripple items-center text-primary-300 hover:text-primary-300 dark:text-primary-300 dark:hover:text-primary-300"
      }, [
        _createVNode(_component_MagicWand, { class: "fa-2x" })
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTagger && _ctx.openTagger(...args))),
        class: "transition mx-auto duration-150 p-3 w-full ripple items-center text-primary-300 hover:text-primary-300 dark:text-primary-300 dark:hover:text-primary-300"
      }, [
        _createVNode(_component_Tag, { class: "fa-2x" })
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeKeyboard && _ctx.closeKeyboard(...args))),
        class: "transition mx-auto duration-150 p-3 w-full ripple items-center text-primary-300 hover:text-primary-300 dark:text-primary-300 dark:hover:text-primary-300"
      }, [
        _createVNode(_component_HideKeyboard, { class: "fa-2x" })
      ])
    ]),
    (_ctx.helperOpen || _ctx.taggerOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({height: _ctx.keyboardHeight + 'px'})
        }, [
          (_ctx.helperOpen)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('Text decorations')), 1),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.text_types, (val, key) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: key,
                      innerHTML: key,
                      onClick: ($event: any) => (_ctx.paste(val)),
                      class: "noselect transition duration-150 bg-gray-100 dark:bg-gray-900 hover:bg-gray-200 dark:hover:bg-gray-700 focus:bg-gray-300 dark:focus:bg-gray-600 px-3 py-2 m-1 rounded-lg max-w-100 h-min"
                    }, null, 8, _hoisted_7))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.taggerOpen)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.$t('Search for user to tag them')), 1))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}